import { ServiceLanguage, Tenant } from "albertine-shared-web";
import { z } from "zod";

export const articleSearchSchema = z.object({
    tenant: Tenant,
    locale: ServiceLanguage,
    id: z.string().min(1),
});

export type ArticleSearch = z.infer<typeof articleSearchSchema>;
